import VillagesHeaderFilter from './Filter';
import MobileVillagesHeader from './Mobile';
import VillagesHeaderRoot from './Root';
import VillagesHeaderSwitch from './Switch';

const VillagesHeader = {
  Root: VillagesHeaderRoot,
  Filter: VillagesHeaderFilter,
  Switch: VillagesHeaderSwitch,
  Mobile: MobileVillagesHeader,
};

export default VillagesHeader;
